// extracted by mini-css-extract-plugin
module.exports = {"header":"bg_header__1ynRM","about":"bg_about__2FqCl"};